import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import NetworkBarGroupLink from '../NetworkBarGroupLink';
import Button from '../../../Button';
import GroupLinkLoader from '../GroupLinkLoader';
import NetworkBarItemGroup from '../NetworkBarItemGroup';
import { useNormalizedUserStream } from '../../../utils/hooks/useStream';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './FoldableGroupList.scss';
const FoldableGroupList = ({ streamId, tabIndex, isCollapsed, selectedItem, selectedItemClassName, title, icon, isFolded, toggleAriaLabel, onFoldToggle, className, prefix, sectionType })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { items: groups, hasMore, isFetching, fetchNext, errorMessage } = useNormalizedUserStream(streamId);
    if (!isFetching && !groups.length && (!hasMore || errorMessage)) {
        return null;
    }
    const hasNewContent = groups.some((group)=>{
        var _group_networkbar;
        return (_group_networkbar = group.networkbar) === null || _group_networkbar === void 0 ? void 0 : _group_networkbar.hasNewContent;
    });
    return /*#__PURE__*/ React.createElement(NetworkBarItemGroup, {
        title: title,
        icon: icon,
        isCollapsed: isCollapsed,
        className: className,
        hasNewContent: hasNewContent,
        withFolding: true,
        isFolded: isFolded,
        toggleAriaLabel: toggleAriaLabel,
        onFoldToggle: ()=>onFoldToggle(sectionType, !isFolded),
        biData: BiData({
            evid: 164,
            is_expanding: isFolded ? 1 : 0,
            indicator: hasNewContent ? 1 : 0
        })
    }, /*#__PURE__*/ React.createElement("ul", null, prefix && /*#__PURE__*/ React.createElement("li", {
        key: "newgroup"
    }, prefix), groups.map((group, index)=>/*#__PURE__*/ React.createElement("li", {
            key: group.userId
        }, /*#__PURE__*/ React.createElement(NetworkBarGroupLink, {
            group: group,
            tabIndex: tabIndex,
            rank: index,
            isCollapsed: !isMobile && isCollapsed,
            isSelected: selectedItem === group.userId,
            className: classnames(selectedItem === group.userId && selectedItemClassName)
        }))), isFetching && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(GroupLinkLoader, {
        isCollapsed: isCollapsed
    })), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(GroupLinkLoader, {
        isCollapsed: isCollapsed
    })), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(GroupLinkLoader, {
        isCollapsed: isCollapsed
    })))), hasMore && !isFetching && !isCollapsed && /*#__PURE__*/ React.createElement(Button, {
        view: "b33",
        className: s['more-button'],
        onClick: fetchNext,
        tabIndex: tabIndex
    }, t('networkBar.groups.showMore')));
};
FoldableGroupList.displayName = 'FoldableGroupList';
export default FoldableGroupList;
